import styled, { css } from 'styled-components'

export const Alert = styled.div.attrs(props => ({
  className: "alert",
}))`
 
`